
  export default {
    props: {
      field: { type: String, required: true },
      inputAttrs: { type: Object, default () { return {}; } },
      modelName: { type: String, required: true },
      radioOptions: { type: Array, default: null },
      required: { type: Boolean, default: true }
    },
    data () {
      return {
        scopeId: null,
        checked: null
      };
    },
    computed: {
      attribute: {
        get () {
          return this.$formGet(this.modelName, this.field);
        },
        set (v) {
          this.checked = v;
          this.$emit('input', v);
        }
      }
    },
    mounted () {
      this.scopeId = this.$uuid.v4();
    },
    methods: {
      elId (option) {
        return [this.scopeId, option.toString()].join('_');
      },
      scrollToFirstError () {
        const firstError = this.$refs.radio.reduce((acc, el) => {
          if (el.name && el.form && !el.form.checkValidity()) {
            const invalidEls = el.form.querySelectorAll(`[name="${el.name}"]:invalid`);
            if (invalidEls.length && !acc) {
              acc = invalidEls[0];
            }
          }
          return acc;
        }, null);

        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      },
      scrollToFirstErrorWithDelay () {
        setTimeout(() => {
          this.scrollToFirstError();
        }, 200);
      }
    }
  };
